<div class="container-fluid">
  <div class="row">
    <les-libraires-overview class="col-12 mb-4"></les-libraires-overview>
  </div>
  <hr />
  <div class="row">
    <shopify-overview class="col-12 mb-4"></shopify-overview>
  </div>
  <hr />
  <div class="row">
    <quickbook-overview class="col-12"></quickbook-overview>
  </div>
</div>